import { Directive, OnInit, OnDestroy, OnChanges, AfterViewInit, SimpleChanges, forwardRef, Input, ElementRef, Output, EventEmitter, ViewChild, HostBinding, Inject, Optional, Host, Renderer2, ChangeDetectorRef, HostListener, DOCUMENT } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormGroupDirective, UntypedFormControl, FormControlName } from '@angular/forms';
import { Subscription, fromEvent } from 'rxjs';
import { VIRTUAL_KEYBOARD_LAYOUT } from './keyboard-layout';

import { CurrentUser } from '@otas/model/current-user';
import { OverlayPanelComponent } from '../overlay-panel/overlay-panel.component';
import * as _ from 'underscore';
import { IKeyBoradOption } from './virtual-keyboard.component';
declare let $: any;

@Directive({
  selector: '[appIndicInput],appIndicInput,indic-input',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IndicInputDirective),
      multi: true
    }
  ],
  exportAs: 'appIndicInput',
  standalone: false
})
export class IndicInputDirective implements OnInit, OnDestroy, OnChanges, AfterViewInit, ControlValueAccessor {

  @Input() type = 'text';
  @Input() placeholder: string;
  @Input() parentEl: ElementRef;
  @Input() class = 'form-control';
  @Output() changed: EventEmitter<string> = new EventEmitter<string>();
  @Input() keyboard: 'english' | 'malayalam' | 'manglish';
  @Input() isClearAll = false;
  @ViewChild('input', { static: false }) inputField: ElementRef;
  @Input() @HostBinding('tabindex') tabindex = -1;
  @Input() /*@HostBinding('attr.disabled')*/ isDisable = false;
  @Input() /* @HostBinding('class')*/ clas = this.isDisable;
  @ViewChild('keyBoardDiv', { static: false }) keyBoardDivRef: ElementRef;

  defaultInputOptions: IKeyBoradOption = {
    keyboardEnable: true,
    inputarea: 'input',
    keyboardPosition: 'auto'
  };
  @Input() inputOptions: IKeyBoradOption = {
    keyboardEnable: true,
    inputarea: 'input',
    keyboardPosition: 'auto'
  };
  array = [];
  selectedKeys = '';
  caretPos: any;
  numbers = [];
  documentClick: Subscription;
  layout = VIRTUAL_KEYBOARD_LAYOUT;
  isMalayalam: boolean;
  isManglish: boolean;
  inputType = 'malayalam';
  manglishPattern;
  constructor(@Inject(DOCUMENT) private document: any, @Optional() @Host() private formGroupDirective: FormGroupDirective,
    public _elementRef: ElementRef, private renderer: Renderer2, private cd: ChangeDetectorRef) {
    // try {
    this.numbers = _.range(0, VIRTUAL_KEYBOARD_LAYOUT.length, 16);
    const currentUser: CurrentUser = sessionStorage.getItem('CURRENT_USER') ? JSON.parse(sessionStorage.getItem('CURRENT_USER')) : null;
    this.isMalayalam = currentUser?.typingLanguage === 'MALAYALAM' ? true : false;
    this.isManglish = currentUser?.typingLanguage === 'MANGLISH' ? true : false;
    this.setInputType();
    // }
    // catch (e) {
    //   this.isMalayalam = true;
    // }
    // console.log(indicInput);

  }
  @ViewChild(OverlayPanelComponent, { static: false }) keyBoardPanel: OverlayPanelComponent;
  onChange = (_f: any) => { };
  onTouched = () => { };
  ngOnInit() {

  }
  setInputType() {
    if (this.keyboard) {
      this.inputType = this.keyboard;
      this.isMalayalam = this.keyboard === 'malayalam';
      this.isManglish = this.keyboard === 'manglish';
    } else {
      if (this.isMalayalam) {
        this.inputType = 'malayalam';
      } else if (this.isManglish) {
        this.inputType = 'manglish';
      } else {
        this.inputType = 'english';
      }
    }
  }
  handleMlInput(value) {
    this.inputField.nativeElement.value = value;
    // this.inputField.nativeElement.blur();
    this.inputField.nativeElement.focus();
    this.onChange(value);
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.inputOptions = Object.assign(this.defaultInputOptions, this.inputOptions);
    if (changes.isDisable) {

      // this.renderer.setProperty(this.inputField.nativeElement, 'disabled', this.isDisable);
      setTimeout(() => {
        // if (this.inputField) {
        this.renderer.setProperty(this.inputField.nativeElement, 'disabled', changes.isDisable.currentValue);
        this.renderer.setAttribute(this._elementRef.nativeElement, 'ng-reflect-is-disable', changes.isDisable.currentValue ? 'true' : 'false');
        // }
      }, 0);
    }
  }
  ngAfterViewInit(): void {

    this.documentClick = fromEvent(document, 'click').subscribe((event: MouseEvent) => {
      if (this.keyBoardPanel) {
        this.keyBoardPanel.afterHide.subscribe(() => { this.toggleKeyBoard(false); })
      }
      if (this.keyBoardPanel &&
        !this._elementRef.nativeElement.contains(event.target as Node) &&
        !this.keyBoardDivRef.nativeElement.contains(event.target as Node)) {
        this.toggleKeyBoard(false);
        this.keyBoardPanel.hide();
      }
    });
  }
  writeValue(obj: any): void {
    this.selectedKeys = !!obj ? obj : '';
    setTimeout(() => {
      this.inputField.nativeElement.value = this.selectedKeys;
    }, 50);
  }
  public validate(c: UntypedFormControl): any {
    const controlValue = c ? c.value : null;
    const autoSuggestDir: FormControlName =
      _.find(this.formGroupDirective.directives, (e: FormControlName) => e.valueAccessor instanceof IndicInputDirective);
    if (autoSuggestDir) {
      return autoSuggestDir.errors && !controlValue ? autoSuggestDir.errors : null;
    }
    return null;
  }
  @HostListener('focus')
  onFocus() {
    // setTimeout(() => {
    this.inputField.nativeElement.focus();
    // }, 50);
  }
  registerOnChange(fn: (_: any) => void): void { this.onChange = fn; }
  registerOnTouched(fn: () => void): void { this.onTouched = fn; }
  setDisabledState?(isDisabled: boolean): void {

    this.isDisable = isDisabled;
    setTimeout(() => {
      if (this.inputField) {
        this.renderer.setProperty(this.inputField.nativeElement, 'disabled', isDisabled);
        this.renderer.setAttribute(this._elementRef.nativeElement, 'ng-reflect-is-disable', isDisabled ? 'true' : 'false');
      }
    }, 0);

  }
  clickButton(value) {

    this.insertAtCaretPos(value);
    this.onChange(this.selectedKeys = this.inputField.nativeElement.value);

  }
  getOffset(el: Element): DOMRect | ClientRect {
    return el.getBoundingClientRect();
  }
  toggleKeyBoard(isOpen) {
    let method = isOpen ? 'appendChild' : 'removeChild';
    if (this.parentEl && this.parentEl?.nativeElement?.closest('table')) {
      const input: { x: number, y: number } = this.inputField.nativeElement.getBoundingClientRect();
      // this.renderer.addClass(this.keyBoardDivRef.nativeElement, 'drag-handle')
      this.renderer.setStyle(this.keyBoardDivRef.nativeElement, 'position', 'absolute');
      this.renderer.setStyle(this.keyBoardDivRef.nativeElement, 'top', 200 + 'px');
      this.renderer.setStyle(this.keyBoardDivRef.nativeElement, 'left', 100 + 'px');
      const tableElement = this.parentEl.nativeElement.closest('table');
      const parent = this.renderer.parentNode(tableElement);

      if (isOpen) {
        this.renderer.insertBefore(parent, this.keyBoardDivRef.nativeElement, parent.firstChild);
        return;
      }
      this.renderer[method](this._elementRef.nativeElement, this.keyBoardDivRef.nativeElement);
    } else {

      this.renderer[method](this._elementRef.nativeElement, this.keyBoardDivRef.nativeElement);

    }
    const rect = this._elementRef.nativeElement.getBoundingClientRect();
    const bodyRect = document.body.getBoundingClientRect();
    if (this.inputOptions.keyboardPosition === 'top') {
      const bottom = rect.bottom - 250;
      this.renderer.setStyle(this.keyBoardDivRef.nativeElement, 'bottom', bottom + 'px');
    } else {
      this.renderer.setStyle(this.keyBoardDivRef.nativeElement, 'top', rect.bottom + 'px');

    }
    this.alignKeyBoardToLeft();
  }
  alignKeyBoardToLeft() {
    const rect = this._elementRef.nativeElement.getBoundingClientRect();
    const keyboardWidth = 1220;
    const bodyRect = document.body.getBoundingClientRect();
    const keyboardStartPos = bodyRect.width - (rect as any).x;
    const left = (keyboardStartPos - (keyboardWidth + ((bodyRect.width - keyboardWidth) / 2)));
    this.renderer.setStyle(this.keyBoardDivRef.nativeElement, 'left', left + 'px');

  }
  openKeyBoard(eve) {

    if (!this.isDisable && this.inputOptions.keyboardEnable) {
      this.toggleKeyBoard(!this.keyBoardPanel.visible);
      if (this.keyBoardPanel.visible) {
        this.keyBoardPanel.hide();
        if (this.parentEl) {
          this.renderer.removeStyle(this.parentEl, 'z-index');
        }
      } else {
        this.keyBoardPanel.show(eve);

        if (this.parentEl) {
          this.renderer.setStyle(this.parentEl, 'z-index', 2);
        }
      }
    }
  }
  keyPress(value) {
    if (!value) { this.onChange(''); } else { this.onChange(value); }
  }
  insertAtCaretPos(text) {

    const document = this.document;
    const node = this.inputField.nativeElement;

    const nodeLen = node.value.length;
    if (document.selection) {
      node.focus();
      const sel = document.selection.createRange();
      sel.text = text;
      node.focus();

    } else if (node.selectionStart || node.selectionStart === 0) {
      const startPos = node.selectionStart;
      const endPos = node.selectionEnd;
      const scrollTop = node.scrollTop;
      const prev = node.value[startPos - 1];


      if (node.value.includes('\u0d0e\u0d46')) {
        node.value = node.value.replace(new RegExp('\u0d0e\u0d46'), '\u0d10');
      }
      if (node.value.includes('\u0d46\u0d46')) {
        node.value = node.value.replace(new RegExp('\u0d46\u0d46'), '\u0d48');
      }
      if (node.value.includes('\u0d12\u0d3e')) {
        node.value = node.value.replace(new RegExp('\u0d12\u0d3e'), '\u0d13');
      }
      if (node.value.includes('\u0d12\u0d57')) {
        node.value = node.value.replace(new RegExp('\u0d12\u0d57'), '\u0d14');
      }
      if ((prev === '\u0d1a' || prev === '\u0d2f' || prev === '\u0d2c' || prev === '\u0d35') && text === '\u0d52') {
        node.value = this.repStrByidx(startPos - 1, node.value, '\u200D');
        text = prev + '\u0d4d' + prev;

      } else if (text === '\u0d52') {
        text = '';
      }
      node.value = node.value.substring(0, startPos) + text + node.value.substring(endPos, nodeLen);
      node.focus();
      node.selectionStart = startPos + text.length;
      node.selectionEnd = startPos + text.length;
      node.scrollTop = scrollTop;
    } else {
      // IE input[type=text] and other browsers
      node.value += text;
      node.focus();
      node.value = node.value;    // forces cursor to end

    }
    this.selectedKeys = node.value;
    this.onChange(node.value.length ? node.value : '');

  }
  repStrByidx(index: number, value: string, replacement: string) {
    return value.substr(0, index) + replacement + value.substr(index + replacement.length);
  }

  onkeyDown(event: KeyboardEvent) {
    const node = this.inputField.nativeElement;
    if (this.isClearAll) {
      if (_.contains([8, 46], event.keyCode)) {

        // if (this.keyBoardPanel && this.keyBoardPanel.visible) {
        // node.blur();
        // setTimeout(() => {
        //   node.focus();
        //   node.value = '';
        //   this.selectedKeys = node.value;
        //   this.onChange(node.value);
        // }, 110);
        // }
      }
    }
    if (_.contains([8, 46], event.keyCode)) {
      // if (node.selectionStart === 0 && node.selectionEnd !== node.selectionStart) {
      //   node.blur();
      //   setTimeout(() => {
      //     node.focus();
      //   }, 110);
      // }
    }

    if (node.value.includes('\u0d46\u0d46')) {
      node.value = node.value.replace(new RegExp('\u0d46\u0d46'), '\u0d48');
    }
    if (node.value.includes('\u0d0e\u0d46')) {
      node.value = node.value.replace(new RegExp('\u0d0e\u0d46'), '\u0d10');
    }
    if (node.value.includes('\u0d12\u0d3e')) {
      node.value = node.value.replace(new RegExp('\u0d12\u0d3e'), '\u0d13');
    }
    if (node.value.includes('\u0d12\u0d57')) {
      node.value = node.value.replace(new RegExp('\u0d12\u0d57'), '\u0d14');
    }
    const currentUser: CurrentUser = sessionStorage.getItem('CURRENT_USER') ? JSON.parse(sessionStorage.getItem('CURRENT_USER')) : null;

    if (event.key === 'F6') {
      event.preventDefault();
      setTimeout(() => { node.focus(); }, 50);
      const isTypingLangManglish = currentUser?.typingLanguage === 'MANGLISH';
      const isTypingLangMalayalam = currentUser?.typingLanguage === 'MALAYALAM';
      const isTypingLangEnglish = currentUser?.typingLanguage === 'ENGLISH';
      if (isTypingLangEnglish) {
        this.isMalayalam = false;
        this.isManglish = false;
      } else if (isTypingLangManglish) {
        this.isManglish = !this.isManglish;
      } else if (isTypingLangMalayalam) {
        this.isMalayalam = !this.isMalayalam;

      }
      this.setInputType();

      if (this.keyBoardPanel && this.keyBoardPanel.visible) {
        this.toggleKeyBoard(false);
        this.keyBoardPanel.hide();
      }
    }
  }
  ngOnDestroy(): void {
    if (this.documentClick) {
      this.documentClick.unsubscribe();
    }
  }
}